import {
  faCalendarDay,
  faCalendarDays,
  faCircleCheck,
  faCircleQuestion,
  faClockRotateLeft,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { goBootpayRequest2, dismissBootpay } from "components/bootpay";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import Style from "css/point_css/point_d.module.css";
import { chargePoint } from "firebase_/firebase_function/point_function";
import { setReceiptLog } from "firebase_/firebase_function/receipt_log";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useUser } from "util/context/user_context";
import { formatNumberWithCommas } from "util/function/function";

const ExpertPointChargeScreen = ({ isMobile }) => {
  const { userData, setUserData } = useUser();
  const price = [100000, 200000, 300000];
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [payBusy, setPayBusy] = useState(false); // 부트페이 결제 진행 중
  //결제
  const handlePayment = async (amount) => {
    const body = {
      price: amount,
      order_name: "포인트 충전",
      user_id: userData.id,
      user_name: userData.name,
      user_phone: userData.phone,
      user_address: userData.address,
    };
    let response;
    setPayBusy(true);
    try {
      response = await goBootpayRequest2(body);
      console.log("결제 요청 성공:", response);
      if (response.event === "done") {
        console.log("결제 완료");
        const result = await chargePoint(userData.id, amount / 100);
        if (result) {
          setModalMessage("포인트 충전이 완료되었습니다.");
        } else {
          setModalMessage("포인트 충전이 실패하였습니다.");
        }
      }
    } catch (error) {
      console.error("결제 요청 중 오류 발생:", error);
      setModalMessage("결제가 취소되었습니다.");
      response = error;
    } finally {
      setPayBusy(false);
    }
    setReceiptLog(userData, response);
    setOnlyConfirmModal(true);
  };

  const cancelPayment = () => {
    dismissBootpay();
    setPayBusy(false);
  };

  return (
    <>
      <div
        className={Style.container}
        style={{
          padding: isMobile ? "32px 16px" : "178px 16px",
          gap: isMobile ? "24px" : "124px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "32px",
            width: "100%",
          }}
        >
          <div className="f30_1F2937_W700">포인트 충전</div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="f20_4B5563_W400">현재 포인트</div>
            <div className="f48_4B5563_W700">
              {formatNumberWithCommas(userData.point)}P
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: "24px",
            width: "100%",
            maxWidth: "1120px",
            justifyContent: "space-between",
          }}
        >
          {price.map((item, index) => (
            <div key={index} className={Style.point_pay_list_item}>
              <div
                className="f24_1F2937_W700"
                style={{ height: "32px", alignContent: "center" }}
              >
                {formatNumberWithCommas(item / 100)}P
              </div>
              <div
                className="f18_059669_W600"
                style={{ height: "28px", alignContent: "center" }}
              >
                ₩{formatNumberWithCommas(item)}
              </div>
              <div
                className={Style.point_pay_list_item_btn + " f16_FFFFFF_W400"}
                onClick={() => handlePayment(item)}
              >
                선택
              </div>
            </div>
          ))}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "64px",
          }}
        >
          <NavLink
            to="/payhistory"
            className="f18_FFFFFF_W600"
            style={{
              width: isMobile ? "100%" : "280px",
              height: "60px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "4px",
              background: "#1F2937",
              borderRadius: "8px",
              cursor: "pointer",
              userSelect: "none",
              textDecoration: "none",
            }}
          >
            <FontAwesomeIcon icon={faClockRotateLeft} />
            결제 내역 보기
          </NavLink>
          <div
            style={{
              display: "flex",
              gap: "32px",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{ display: "flex", gap: "16px", flexDirection: "column" }}
            >
              <div
                className="f14_374151_W600"
                style={{ height: "20px", alignContent: "center" }}
              >
                Important Notes
              </div>
              <div>
                <div
                  className="f14_4B5563_W400"
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "20px",
                        width: "20px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FontAwesomeIcon icon={faCircleCheck} color="#10B981" />
                    </div>
                    포인트는 구매일로부터 5년간 환불 가능하며, 환불 시 10%가
                    공제됩니다.
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "20px",
                        width: "20px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FontAwesomeIcon icon={faCalendarDays} color="#10B981" />
                    </div>

                    <div>환불 시 지급된 보너스 포인트는 전액 소멸 됩니다</div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "20px",
                        width: "20px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <FontAwesomeIcon icon={faReceipt} color="#10B981" />
                    </div>
                    최종 사용일로부터 60개월 경과 시, 포인트는 자동 소멸됩니다.
                  </div>
                </div>
              </div>
            </div>
            <div
              className="f14_059669_W400"
              style={{
                display: "flex",
                gap: "4px",
                height: "20px",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon icon={faCircleQuestion} />
              <div>궁금한 점이 있으신가요?</div>
              <NavLink
                to=""
                className="f14_059669_W400"
                style={{ textDecoration: "none" }}
              >
                {"[포인트 충전 FAQ 보기]"}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <OnlyConfirmDialog
        open={onlyConfirmModal}
        onClose={() => {
          setOnlyConfirmModal(false);
          window.location.reload();
        }}
        message={modalMessage}
      />

      {/* 결제 진행 중 부트페이 창 강제 종료 버튼 (창 밖 클릭으로는 안 닫혀서 추가) */}
      {payBusy && (
        <button
          type="button"
          onClick={cancelPayment}
          style={{
            position: "fixed",
            top: 16,
            right: 16,
            zIndex: 2147483647,
            padding: "10px 16px",
            borderRadius: 9999,
            border: "1px solid #FECACA",
            background: "rgba(0,0,0,0.78)",
            color: "#fff",
            fontSize: 13,
            fontWeight: 800,
            cursor: "pointer",
            boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
          }}
        >
          ✕ 결제 취소
        </button>
      )}
    </>
  );
};

export default ExpertPointChargeScreen;
